export { default } from './svg/align-left.svg';
